import JustValidate from "just-validate";

class JustValidateCustom extends JustValidate {
    #isValid = false;
    #onValidChangeListeners = new Set();
    isDirty = false;

    constructor(...args) {
        super(...args);

        Object.defineProperty(this, "isValid", {
            get: () => this.#isValid,
            set: (value) => {
                this.#isValid = value;
                this.isDirty = this.#isAllDirty();
                this.#onValidChangeListeners.forEach((cb) => cb(value));
            },
        });
    }

    #setIsSubmitted(isSubmitted = true) {
        this.isSubmitted = isSubmitted;
        if (isSubmitted) this.form.classList.add("submitted");
        else this.form.classList.remove("submitted");
    }

    onIsValidChange(cb) {
        this.#onValidChangeListeners.add(cb);
    }

    #isAllDirty() {
        return Object.values(this.fields).every(
            (field) => field.isValid !== undefined
        );
    }

    submit() {
        this.#setIsSubmitted(true);

        return this.revalidate().then((isValid) => {
            if (isValid) {
                const values = {};
                for (const [id, key] of this.fieldIds.entries()) {
                    values[id] = this.fields[key].elem.value;
                }

                return { isValid, values };
            }

            return { isValid };
        });
    }

    areAllFieldsFilled() {
        return Object.values(this.fields).every((field) => field.elem.value);
    }
}

function registerFormValidator(rules, config) {
    if (!rules) {
        console.error("registerFormValidator: No rules provided");
        return;
    }

    if (typeof rules !== "object") {
        console.error("registerFormValidator: Rules must be an object");
        return;
    }

    const validator = new JustValidateCustom(`#${rules.id}`, {
        errorLabelStyle: {},
        ...config,
    });

    Object.values(rules).forEach((value) => {
        if (typeof value === "object") {
            try {
                validator.addField(`#${value.id}`, value.rules);
            } catch {

            }
        }
    });

    return validator;
}

function showValidatorCustomError(inputContainer, text) {
    const textInput = inputContainer.querySelector('.text-input')
    if (!textInput) return;

    inputContainer.classList.add('submitted')
    const p = document.createElement('p')
    p.classList.add('just-validate-error-label')
    p.innerText = text;
    inputContainer.appendChild(p)
    textInput.classList.add('just-validate-error-field')
}

function clearValidatorCustomError(inputContainer) {
    const textInput = inputContainer.querySelector('.text-input')
    if (!textInput) return;

    const p = inputContainer.querySelector('.just-validate-error-label')
    if (p) p.remove()
    textInput.classList.remove('just-validate-error-field')
}

function hasValidatorCustomError(inputContainer) {
    const textInput = inputContainer.querySelector('.text-input')
    if (!textInput) return;

    return textInput.classList.contains('just-validate-error-field')
}

export { JustValidateCustom, registerFormValidator, showValidatorCustomError, clearValidatorCustomError, hasValidatorCustomError };
